import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { propTypes } from '../../util/types';
import StaticPage from '../PageBuilder/StaticPage';
import { LayoutComposer } from '../../components';
import css from '../PageBuilder/PageBuilder.module.css';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import './LandingPage.css';
import classNames from 'classnames';
import FootFallLandingPage from './LandingPageSections/LandingPageV2';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const LandingPageComponent = props => {
  const {
    pageAssetsData,
    inProgress,
    error,
    fallbackPage,
    schemaType,
    options,
    currentPage,
    ...pageProps
  } = props;

  if (!pageAssetsData && fallbackPage && !inProgress && error) {
    return fallbackPage;
  }

  // Page asset contains UI info and metadata related to it.
  // - "sections" (data that goes inside <body>)
  // - "meta" (which is data that goes inside <head>)
  const { sections = [], meta = {} } = pageAssetsData?.landingPage?.data || {};

  const layoutAreas = `
    topbar
    main
    footer
  `;

  return (
    <StaticPage {...pageProps}>
      <LayoutComposer areas={layoutAreas} className={classNames(css.layout)}>
        {props => {
          const { Topbar, Main, Footer } = props;
          return (
            <>
              <div>
                <div className={css.topbarAndMain}>
                  <Topbar as="header" className={css.topbar}>
                    <TopbarContainer currentPage={currentPage} desktopClassName={css.topbar} />
                  </Topbar>
                  <Main as="main" className={css.main}>
                    <div className={css.content}>
                      <FootFallLandingPage />
                      {/*{sections.length > 0 && (*/}
                      {/*  <PageBuilder*/}
                      {/*    pageAssetsData={pageAssetsData?.[camelize(ASSET_NAME)]?.data}*/}
                      {/*    inProgress={inProgress}*/}
                      {/*    error={error}*/}
                      {/*    fallbackPage={<FallbackPage error={error} />}*/}
                      {/*    showTopbar={false}*/}
                      {/*    showFooter={false}*/}
                      {/*    className={css.pageSections}*/}
                      {/*  />*/}
                      {/*)}*/}
                    </div>
                  </Main>
                </div>

                <Footer>
                  <FooterContainer />
                </Footer>
              </div>
            </>
          );
        }}
      </LayoutComposer>
    </StaticPage>
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};
// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(connect(mapStateToProps))(LandingPageComponent);

export default LandingPage;
